module.exports = __webpack_public_path__ + "media/elevadizo/buque-ap-8ba000a6.png";